import _ from 'lodash';
import moment from 'moment';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
//- material-ui

import { withStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import WarningIcon from '@material-ui/icons/Warning';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import TextField from '@material-ui/core/TextField';

//- local
import ReportsMonitoringContainer from '../../containers/reports/Monitoring';
import EnhancedTableHead from '../../components/EnhancedTableHead';
import { sortStationTable } from '../../libs/utility';
import AddInventoryDialog from '../../components/AddInventoryDialog';
import StationsContainer from '../../containers/Stations';
import { getSharedStyles } from '../../themes';
import InitialLoading from '../../components/InitialLoading';
import SaleCell from '../../components/SaleCell';

// NOTE REMEMBER TO ADD THEM TO THE BACKEND AS WELL
// Just search for STATIONS_TO_HIDE
const R043_ID = 109; // R043
const R212_ID = 619; // R212
const R302_ID = 754; //  station is not cooperating with providing inventory
const R399_ID = 825; // Simi Valley (Tapo St)
const STATIONS_TO_HIDE = [R043_ID, R212_ID, R302_ID, R399_ID];

const styles = (theme) => ({
	...getSharedStyles(theme),
	row: {
		cursor: 'pointer',
	},
	button: {
		fontWeight: 400,
		verticalAlign: 'middle',
		padding: '5px 14px 6px 5px',
		borderRadius: 100,
		fontSize: 12,
		minHeight: 32,
		marginRight: 1,
		marginLeft: 1,
		//border : `1px solid rgba(30,30,30,.05)`,
	},

	updateVolume: {
		fontWeight: 500,
		verticalAlign: 'middle',
		padding: '4px 10px 4px 10px',
		borderRadius: 100,
		fontSize: 14,
		minHeight: 32,
		marginRight: 1,
		marginLeft: 1,
		border: `1px solid rgba(30,30,60,.3)`,
	},

	formControl: {
		fontSize: 14,
		marginLeft: 20,
		flex: 1,
	},
	title: {
		display: 'flex',
		alignItems: 'flex-end',
	},
	leftIcon: {
		marginRight: -2,
		color: '#FFC107',
		height: 16,
	},
	saleCell: {
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'flex-end',
	},
});

const productTypeToDisplay = {
	e85: 'E85',
	//bioDiesel : 'Bio-Diesel'
};

class StationInventory extends Component {
	constructor(props) {
		super(props);

		const lookBack = _.get(this.props, ['match', 'params', 'lookBack']);
		let lookBackAmount = 0;

		if (lookBack) {
			const parts = lookBack.match(/[a-zA-Z]+|[0-9]+/g);
			lookBackAmount = parseInt(parts[1]);
		}

		this.state = {
			order: 'asc',
			orderBy: 'number',
			orderInactive: 'asc',
			orderByInactive: 'number',
			infoForAdd: {},
			isAddDialogOpen: false,
			search: '',
			lookBack,
			lookBackAmount,
		};
	}

	componentDidMount() {
		const {
			stations,
			searchStations,
			tankDailyInventories,
			getTankDailyInventories,
			tankDailySales,
			getTankDailySales,
		} = this.props;

		if (!tankDailyInventories) {
			getTankDailyInventories({});
		}

		if (!tankDailySales) {
			getTankDailySales({});
		}

		if (_.isEmpty(stations)) {
			searchStations();
		}
	}

	componentDidUpdate(prevProps) {
		const lookBack = _.get(this.props, ['match', 'params', 'lookBack']);
		if (!lookBack && prevProps.match.params.lookBack) {
			this.setState({ lookBack: null, lookBackAmount: 0 });
		} else if (lookBack && lookBack !== prevProps.match.params.lookBack) {
			const parts = lookBack.match(/[a-zA-Z]+|[0-9]+/g);
			const lookBackAmount = parseInt(parts[1]);
			this.setState({ lookBack, lookBackAmount });
		}

		if (
			this.props.location &&
			prevProps.location &&
			this.props.location.pathname !== prevProps.location.pathname
		) {
			//window.scrollTo(0, 0);
		}
	}

	handleAddNewInventory = () => {
		this.setState({
			infoForAdd: {},
			isAddDialogOpen: true,
		});
	};

	handleOpenAddDialog = ({ infoForAdd }) => {
		this.setState({
			infoForAdd,
			isAddDialogOpen: true,
		});
	};

	handleCloseAddDialog = () => {
		this.setState({ isAddDialogOpen: false });
	};

	handleSearch = (event) => {
		this.setState({ search: event.target.value });
	};

	handleRowClick = (stationId, tankNumber) => {
		this.props.history.push(`/reports/stationVolume/${stationId}/${tankNumber}`);
	};

	handleRequestSort = (property) => {
		const orderBy = property;
		let order = 'desc';

		if (this.state.orderBy === property && this.state.order === 'desc') {
			order = 'asc';
		}
		this.setState({ order, orderBy });
	};

	handleRequestSortInActive = (property) => {
		const orderByInactive = property;
		let orderInactive = 'desc';

		if (this.state.orderByInactive === property && this.state.orderInactive === 'desc') {
			orderInactive = 'asc';
		}
		this.setState({ orderInactive, orderByInactive });
	};

	render() {
		const {
			classes,
			tankDailyInventories,
			stationMap,
			gasFormulaMap,
			rackFormulaMap,
			authUser,
			tankDailySales,
		} = this.props;

		if (
			!tankDailyInventories ||
			!gasFormulaMap ||
			!rackFormulaMap ||
			!authUser ||
			!stationMap ||
			!tankDailySales
		) {
			return <InitialLoading />;
		}

		const {
			order,
			orderBy,
			orderInactive,
			orderByInactive,
			search,
			lookBack,
			lookBackAmount,
		} = this.state;
		const canMakeUpdates = _.get(authUser, ['permissions', 'canMakeUpdates']);

		//
		//- Daily

		const dailyInventoryColumns = [
			//{ id: 'number', numeric: false, label: 'Number' },
			{ id: 'displayName', numeric: false, label: 'Name' },
			//{ id: 'productAndTank', numeric: false, label: 'Product / Tank', disablePadding : true },
		];

		const last10Days = [];

		if (lookBack) {
			if (lookBackAmount) {
				_.range(lookBackAmount, lookBackAmount + 10).forEach((i) => {
					last10Days.push(moment().subtract(i, 'day'));
				});
			} else {
				_.range(10, 20).forEach((i) => {
					last10Days.push(moment().subtract(i, 'day'));
				});
			}
		} else {
			_.range(0, 10).forEach((i) => {
				last10Days.push(moment().subtract(i, 'day'));
			});
		}

		last10Days.forEach((date, i) => {
			const monthDay = date.format('MM/DD');
			const day = date.format('ddd');
			dailyInventoryColumns.push({
				id: `day${i}`,
				numeric: true,
				disablePadding: true,
				label: (
					<div style={{ textAlign: 'center' }}>
						{monthDay} {day}
						<br />
						Sale / Inv
					</div>
				),
			});
		});

		//- remove filtered rows
		const cleanSearch = search.replace(/[^a-z0-9]/gi, '');
		const re = new RegExp('^' + cleanSearch, 'i');
		const notGmRe = new RegExp(/GM.*/);

		const salesByStationTank = {};
		tankDailySales.forEach((tankDailySale) => {
			const { stationId, tankNumber, sales } = tankDailySale;
			salesByStationTank[`${stationId}_${tankNumber}`] = sales;
		});

		const dailyInventoriesInactive = [];
		const dailyInventories = tankDailyInventories.reduce((result, record) => {
			const { stationId, tankNumber, productType, isGmoc, inventories } = record;

			if (_.includes(STATIONS_TO_HIDE, stationId)) {
				return result;
			}

			//- We don't have inventory levels for GMOC
			if (isGmoc) {
				return result;
			}

			const { name, number, stationIsNotActive } = stationMap[stationId];
			if (notGmRe.test(number)) {
				return result;
			}

			if (search && !re.test(number) && !re.test(name)) {
				return result;
			}

			const productDisplay = productTypeToDisplay[productType];

			const displayName = `${number} - ${name}`;

			const row = _.merge({
				stationId,
				tankNumber,
				number,
				name,
				displayName,
				rowClick: () => this.handleRowClick(stationId, tankNumber),
				productAndTank: `${productDisplay} / ${tankNumber}`,
			});

			const dateMap = _.keyBy(inventories, (inventory) => {
				return moment(inventory.date).format('MM-DD');
			});

			const _getDaysVolume = (day) => {
				const dateKey = moment(day).format('MM-DD');
				return _.get(dateMap, [dateKey], {});
			};

			const sales = salesByStationTank[`${stationId}_${tankNumber}`];

			const salesDateMap = _.keyBy(sales, (sale) => {
				return moment(sale.date).format('MM-DD');
			});
			const _getSale = (day) => {
				const dateKey = moment(day).format('MM-DD');
				return _.get(salesDateMap, [dateKey], {});
			};

			last10Days.forEach((day, i) => {
				const { volume, inventoryRecordId } = _getDaysVolume(day);

				//- New showing amount
				const salesRow = _getSale(day) || {};
				const dayColumn = `day${i}`;
				if (volume && inventoryRecordId) {
					//row[dayColumn] = volume;

					row[dayColumn] = (
						<div className={classes.saleCell}>
							<SaleCell salesRow={salesRow} doNotShowQuestion={true} />
							<span style={{ padding: '5px 5px' }}> / </span>
							<Button
								className={classes.updateVolume}
								variant="outlined"
								size="small"
								onClick={(e) => {
									e.preventDefault();
									e.stopPropagation();
									this.handleOpenAddDialog({
										infoForAdd: {
											inventoryRecordId,
											stationId,
											tankNumber,
											productType,
											number,
											name,
											day: moment(day).hour(5).minute(30),
											volume,
										},
									});
								}}
							>
								{volume}
							</Button>
						</div>
					);
					return;
				}

				//- Missing a volume for a day. Show an update button
				if (!canMakeUpdates) {
					row[dayColumn] = (
						<div>
							<WarningIcon className={classes.leftIcon} /> Missing
						</div>
					);
					return;
				}

				row[dayColumn] = (
					<div>
						<Button
							className={classes.button}
							variant="outlined"
							size="small"
							onClick={(e) => {
								e.preventDefault();
								e.stopPropagation();
								this.handleOpenAddDialog({
									infoForAdd: {
										stationId,
										tankNumber,
										productType,
										number,
										name,
										day: moment(day).hour(5).minute(30),
									},
								});
							}}
						>
							<WarningIcon className={classes.leftIcon} />
							<span style={{ marginTop: 2 }}>Add</span>
						</Button>
					</div>
				);
			});

			if (stationIsNotActive) {
				dailyInventoriesInactive.push(row);
			} else {
				result.push(row);
			}
			return result;
		}, []);
		const dailyInventoryRows = sortStationTable({ rows: dailyInventories, orderBy, order });
		const dailyInventoryRowsInactive = sortStationTable({
			rows: dailyInventoriesInactive,
			orderBy: orderByInactive,
			order: orderInactive,
		});

		return (
			<Grid container spacing={3}>
				<Grid item xs={12}>
					<Grid container spacing={3}>
						<Grid item xs={12} md={6}>
							<Typography variant="h5" align="left" gutterBottom className={classes.title}>
								<span>Station Inventories / Sales</span>
								<span style={{ fontSize: 14, paddingLeft: 5 }}>(morning readings)</span>
								<TextField
									className={classes.formControl}
									value={this.state.search}
									onChange={(event) => this.handleSearch(event)}
									label="Type to search"
									fullWidth
								/>
							</Typography>
						</Grid>
						<Grid item xs={6} style={{ textAlign: 'right' }}>
							<Button
								variant="contained"
								color="primary"
								style={{
									borderRadius: 100,
									textDecoration: 'none',
									marginTop: 10,
									marginBottom: 3,
								}}
								onClick={this.handleAddNewInventory}
							>
								ADD MORNING STATION INVENTORY
							</Button>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						<div style={{ fontSize: '11', color: '#666' }}>
							Note: Intentionally not showing R043 San Bruno, R212 Sacramento (El Camino Ave), and
							R302 Santa Cruz (station is not cooperating with providing inventor)
						</div>

						<div style={{ textAlign: 'right', paddingRight: 20 }}>
							{lookBack && (
								<Button
									color={'primary'}
									variant="outlined"
									size="small"
									onClick={() => {
										this.props.history.push(`/logistics/inventory`);
									}}
								>
									&lt; Current
								</Button>
							)}

							{lookBackAmount <= 10 && (
								<Button
									color={'primary'}
									variant="outlined"
									size="small"
									style={{ marginLeft: 5 }}
									onClick={() => {
										this.props.history.push(`/logistics/inventory/back${lookBackAmount + 10}`);
									}}
								>
									{lookBackAmount + 10} Days Back &gt;
								</Button>
							)}
						</div>

						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={dailyInventoryColumns}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{dailyInventoryRows.map((n) => {
									return (
										<TableRow
											hover
											className={classes.row}
											style={{ backgroundColor: n.isSelected ? '#ef9a9a' : undefined }}
											key={`${n.stationId}_${n.tankNumber}`}
										>
											<TableCell onClick={n.rowClick}>
												{n.displayName}{' '}
												<span style={{ fontSize: 12, color: '#666' }}>({n.productAndTank})</span>
											</TableCell>

											{last10Days.map((day, i) => {
												return (
													<TableCell key={i} padding={'none'} align="right">
														{n[`day${i}`]}
													</TableCell>
												);
											})}
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>

					<Grid item xs={12} style={{ marginTop: 20 }}>
						<Grid container spacing={3}>
							<Grid item xs={12} md={6}>
								<Typography variant="h5" align="left" gutterBottom className={classes.title}>
									<span>Inactive Station Inventories / Sales</span>
								</Typography>
							</Grid>
						</Grid>
					</Grid>

					<Paper className={classes.paper}>
						<Table stickyHeader size="small" className={classes.table}>
							<EnhancedTableHead
								columnData={dailyInventoryColumns}
								order={order}
								orderBy={orderBy}
								onRequestSort={this.handleRequestSort}
							/>
							<TableBody>
								{dailyInventoryRowsInactive.map((n) => {
									return (
										<TableRow
											hover
											className={classes.row}
											style={{ backgroundColor: n.isSelected ? '#ef9a9a' : undefined }}
											key={`${n.stationId}_${n.tankNumber}`}
										>
											<TableCell onClick={n.rowClick}>
												{n.displayName}{' '}
												<span style={{ fontSize: 12, color: '#666' }}>({n.productAndTank})</span>
											</TableCell>

											{last10Days.map((day, i) => {
												return (
													<TableCell key={i} padding={'none'} align="right">
														{n[`day${i}`]}
													</TableCell>
												);
											})}
										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</Paper>
				</Grid>

				<AddInventoryDialog
					onClose={this.handleCloseAddDialog}
					addInventoryRecord={this.props.addInventoryRecord}
					updateInventoryRecord={this.props.updateInventoryRecord}
					infoForAdd={this.state.infoForAdd}
					open={this.state.isAddDialogOpen}
					stations={this.props.stations}
					showErrors={this.props.showErrors}
					isMorning={true}
				/>
			</Grid>
		);
	}
}

StationInventory.propTypes = {
	classes: PropTypes.object.isRequired,
	getTankDailyInventories: PropTypes.func.isRequired,
	tankDailyInventories: PropTypes.array,

	getTankDailySales: PropTypes.func.isRequired,
	tankDailySales: PropTypes.array,

	stations: PropTypes.array,
	searchStations: PropTypes.func.isRequired,

	stationMap: PropTypes.object,
	rackFormulaMap: PropTypes.object,
	gasFormulaMap: PropTypes.object,

	addInventoryRecord: PropTypes.func.isRequired,
	updateInventoryRecord: PropTypes.func.isRequired,

	order: PropTypes.string,
	orderBy: PropTypes.string,
	history: PropTypes.object,
	match: PropTypes.object,
	location: PropTypes.object,

	authUser: PropTypes.object,
	showErrors: PropTypes.func.isRequired,
};

export default _.flow([withStyles(styles), ReportsMonitoringContainer, StationsContainer])(
	StationInventory
);
